<template>
  <div class="IschromeIOS">
    <div class="IschromeIOS__all">
      <div class="IschromeIOS__cover" />

      <div class="IschromeIOS__lang" @click="$root.langSwitch()">
        {{ lang == 'fr' ? 'en' : 'fr' }}
      </div>

      <div class="IschromeIOS__logo">
        <img :src="require('@/commons/img/logo_alegria.png')" />
      </div>

      <div class="IschromeIOS__nocam">
        <div class="IschromeIOS__nocam-text" v-html="trans('nocam')"/>
      </div>
    </div>

  </div>
</template>

<script>
import Frame from '@/components/frame/Frame'

export default {
  name: 'chromeIOS',
  components: { Frame },
  translations: {
    en: {
      nocam: `
        Oh! Please use safari!<br><br>
        This experience uses the cameras of your phone,
        which works using Safari.
      `,
    },
    fr: {
      nocam: `
        Oh! Utilisez plutôt Safari!<br><br>
        Cette experience utilise les caméras de votre téléphone,
        fonctionnant seulement avec Safari.
      `,
    },
  },
  created() {
    dataLayer.push({
      "useCaseStep": { "Id": "UCS546 - Other - Any other page | PV", "trackType": "PV" },
      "event": "VPV",
      "page": {
        ...this.tracking.page,
        contentName: "other",
        gaStep: 'ischromeios',
        requestURI: this.tracking.page.requestURI + "ischromeios",
      },
      show: this.tracking.show
    })
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.IschromeIOS
  position fixed
  top 0
  left 0
  z-index 999999
  height 100%
  width 100%
  overflow hidden
  text-align center
  text-transform uppercase

  &__lang
    position fixed
    right 20px
    top 27px
    color gold-light
    z-index 9999999999
    font-weight 700
    text-transform uppercase
    font-size 12px

  &__nocam
    position relative
    margin 300px 20px
    &-text
      position absolute
      top 50%
      left 50px
      right 50px
      transform translateY(-50%)
      line-height 24px
      font-size 16px

  &__all
    padding-top 20px
    text-align center
    background-image url('~@/pages/home/img/bg.jpg')
    background-size cover
    background-position center center
    height 100%
    transition filter 1s, transform 1s
    &.is-blur
      filter blur(8px)
      transform scale(1.1)

  &__logo
    width 150px
    margin 0 auto
    &.is-small
      margin 10px auto 10px

</style>
